import React from "react";

function Footer() {
  return (
    <div className="topbar">
      <div className="container-fluid">
        <div className="footer">
          <p>
            Copyright © 2018 Designed by html.design. All rights reserved.
            <br />
            <br />
            Distributed By:{" "}
            <a href="https://themewagon.com/" target="_blank" rel="noopener noreferrer">
              ThemeWagon
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default Footer;
